enum MeetingActionTypes {
  ADD_MEETING = "ADD_MEETING",
}

export default MeetingActionTypes
